<template>
  <el-row :gutter="gutter">
    <el-col :span="span" v-for="item in data" ref="elementItem" :key="item[props.id || `id`]">
        <div class="element-item-container" :style="bodyClass">
          <div class="element-item-content" @click="$emit('el-item-click', item)">
            <img :src="item[props.url || `url`] + '?x-oss-process=style/image_compression_q60'"/>
            <div class="element-item-menu"  v-if="showMenu">
              <dropdown-menu :data="item" :menu="menu"></dropdown-menu>
            </div>
            <span class="element-item-count" v-if="showCount">{{item[props.count || `count`] || 0}} {{unit}}</span>
          </div>
          <div class="element-item-footer" :title="item[props.name || 'name']">
            <div style="float: left" :class="{'button-position': position}">
              <el-radio v-if="radio && !checkBox" v-model="radios" @change="checkRadio(item)" :label="item.id"></el-radio>
              <el-checkbox @change="changeBox(item)" v-model="item.check"  v-if="checkBox && !radio" :key="item.id"></el-checkbox>
            </div>
              {{item[props.name || 'name'] | subName}}
          </div>
        </div>
    </el-col>
  </el-row>
</template>

<script>
import DropdownMenu from '@/components/element/dropdown-menu.vue'
export default {
  components: {DropdownMenu},
  props: {
    bodyClass: String, // 样式
    showMenu: false, // 是否显示菜单
    menu: { // 菜单
      type: Array,
      default: () => [
        {id: 1, value: '移动'},
        {id: 2, value: '删除'},
        {id: 3, value: '重命名'}
      ]
    },
    props: { // 指定名称显示
      type: Object,
      default: () => {
        return {
          id: 'id',
          check: 'check',
          name: 'name',
          url: 'url',
          count: 'count'
        }
      }
    },
    checkBox: Boolean, // 显示复选框
    data: { // 显示的数据
      type: Array,
      default: () => []
    },
    showCount: { // 显示数量
      type: Boolean,
      default: false
    },
    radio: { // 单选框
      type: Boolean,
      default: false
    },
    unit: String, // 数量单位
    span: {
      type: Number,
      default: 4
    }, // 栅栏格数
    gutter: {
      type: Number,
      default: 20
    },
    position: { // 改变位置
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      radios: '',
      checkList: null
    }
  },
  filters: {
    subName (val) {
      if (!val) {
        return
      }
      if (val.length > 13) {
        return val.substr(0, 10) + '...'
      }
      return val
    }
  },
  methods: {
    checkAll () { // 选中所有的复选框
      this.data.forEach(item => {
        this.$set(item, this.props.check || `check`, true)
      })
    },
    cancelCheck () { // 反选
      this.data.forEach(item => {
        this.$set(item, this.props.check || `check`, !item.check)
      })
    },
    changeBox (value) { // 改变选择框
      this.$emit('change-box', value)
    },
    checkRadio (val) { // 单选按钮改变事件
      this.$emit('change-radio', val)
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/variable.scss';
.element-item-container { // 元素显示的容器
  width: 100%;
  height: 196px;
  float: left;
  border: 1px solid $default_color;
  box-sizing: border-box;
  margin-bottom: 20px;
  position: relative;
  .element-item-content {
    height: 81%;
    width: 100%;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .element-item-footer {
    width: 100%;
    height: 19%;
    border-top: 1px solid $default_color;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    line-height: 32px;
    padding: 2px 7px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    .el-radio__label {
      font-size: 0px;
    }
    .button-position {
      position: absolute;
      top: 0px;
    }
  }
  .element-item-menu {
    /*background: white;*/
    position: absolute;
    top:5px;
    right: 6%;
  }
  .element-item-count {
    display: inline-block;
    background: black;
    opacity: 0.5;
    padding: 2px 10px;
    color: $white_color;
    position: absolute;
    right: 10px;
    bottom: 10px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/element/element-item.vue